const PASSWORD_MIN_LENGTH = 8;

const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=^])[\w$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=^]{8,}$/;

export { PASSWORD_MIN_LENGTH, PASSWORD_PATTERN };
